import { SELECT_SHOPPING_CENTER } from 'actions/shoppingCenter';

export default (state=null, action) => {
	switch (action.type) {
		case SELECT_SHOPPING_CENTER:
			return action.payload;
		default:
			return state;
	}
};